var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"url":_vm.url,"title":"تراکنش های ریفاند","fields":_vm.fields,"params":_vm.params,"isForExcel":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }